import * as Yup from "yup";

export const WhitelabelSchema = Yup.object().shape({
  name: Yup.string().trim().required("Required"),
});
